import { CAPABILITIES, rolesWith } from '../utils/capabilities';

const LOGBOOK_MANAGER_ROLES: readonly string[] = rolesWith(
  CAPABILITIES.CreateLogbookEntry
);

/** Shared display policy; server operations also verify current membership. */
export function canManageLogbook(role: string | null | undefined): boolean {
  return Boolean(role && LOGBOOK_MANAGER_ROLES.includes(role));
}

export function canEditDraft(
  role: string | null | undefined,
  userId: string,
  authorId: string
): boolean {
  return canManageLogbook(role) && userId === authorId;
}
